<template>
  <div>
    <div class="coreMailContainer">
      <div class="coreMailContentContainer">
        <div class="header">
          <div class="title">Cofocus</div>
        </div>
        <div class="content">
          <div class="displayName">Greetings Gracia!</div>
          <div class="coreText">
            Someone requested that the password for your Cofocus account be
            reset.
          </div>
          <router-link to="www.google.com" class="coreButton"
            >Reset My Password</router-link
          >
          <div class="resetLink">
            The link is valid for 30 minutes after requesting it.
          </div>
          <div class="resetLink extratop">Copyable link:</div>
          <router-link to="www.google.com" class="copyableLink"
            >www.google.com</router-link
          >
        </div>
        <div class="footer">
          <div class="note">
            If you didn't request this, you can ignore this email or let us
            know. Your password won't change until you create a new password.
          </div>
        </div>
        <div class="cofocus">
          <router-link to="https://www.cofocus.one">Cofocus.one</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "EmailDesigner",
  computed: {
    ...mapState({
      authenticated: (state) => state.auth.authenticationStatus,
      ready: (state) => state.auth.ready,
    }),
  },
  data() {
    return {
      loaded: false,
      link:
        "http://www.cofocus.one/account/resetpassword/c0d7d092b4f7da873f69a83d1e07b4583a0feca9432d1de774b190a754a1868d",
    };
  },
  created() {
    if (this.ready) {
      this.loaded = true;
    }
  },
};
</script>

<style scoped>
.coreMailContainer {
  height: 100%;
}
.coreMailContentContainer {
  width: 500px;
  margin: 0 auto;
  margin-top: 20px;
}

.header {
  align-items: center;
  justify-content: center;
  padding: 30px 0px;
  font-size: 48px;
  font-weight: 700;
  text-align: center;
  padding-top: 60px;
  width: 500px;
  margin-left: auto;
  margin-right: auto;
}

.content {
  text-align: center;
}

.coreText {
  font-size: 22px;
  margin-top: 45px;
  margin-left: auto;
  width: 500px;
  line-height: 27px;
  margin-right: auto;
}

.coreButton {
  padding: 10px 4px;
  width: 315px;
  margin: 0 auto;
  background-color: #efefef;
  font-size: 29px;
  border-radius: 360px;
  font-weight: 600;
  margin-top: 50px;
  text-align: center;
}

a.coreButton {
  text-decoration: none;
  color: #2d2d2d;
  font-weight: bold;
}

.resetLink {
  font-size: 17px;
  margin-top: 20px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}

.footer {
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 13px 25px;
  margin-top: 65px;
  font-size: 15px;
  line-height: 22px;
  max-width: 482px;
  margin-left: auto;
  color: #676767;
  margin-right: auto;
  background-color: #f9f9f9;
  border-radius: 360px;
}

.cofocus {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
  padding-top: 35px;
  text-decoration: none;
  padding-bottom: 45px;
  line-height: 18px;
}
a {
  color: #555;
}
.copyableLink {
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  max-width: 400px;
  word-break: break-word;
  line-height: 28px;
}

.extratop {
  margin-top: 35px;
}
.displayName {
  font-size: 34px;
  margin-top: 30px;
  width: 500px;
  line-height: 27px;
}
</style>